module.exports = __webpack_public_path__ + "img/parking-lot.6c967636.svg";